export default __webpack_public_path__ + "static/media/malta.380301fc.jpg";